import React from 'react';
import { MapPin, Phone, Clock, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-3xl font-bold text-white mb-4">
              N1 <span className="text-orange-500">Grill</span>
            </h3>
            <p className="text-gray-400 mb-4 leading-relaxed">
              London's best value grill serving authentic burgers, doner wraps and wings in the heart of Chapel Market.
            </p>
            <div className="flex gap-1">
              {[...Array(4)].map((_, i) => (
                <span key={i} className="text-yellow-400 text-xl">★</span>
              ))}
              <span className="text-gray-600 text-xl">★</span>
            </div>
            <p className="text-gray-400 text-sm mt-1">4.0 (231 reviews)</p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Contact</h4>
            <div className="space-y-3">
              <a 
                href="tel:02078333399" 
                className="flex items-center gap-2 text-gray-400 hover:text-orange-500 transition-colors duration-300"
              >
                <Phone className="h-4 w-4" />
                <span>020 7833 3399</span>
              </a>
              <div className="flex items-center gap-2 text-gray-400">
                <Mail className="h-4 w-4" />
                <span>info@n1grill.co.uk</span>
              </div>
            </div>
          </div>

          {/* Location */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Location</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2 text-gray-400">
                <MapPin className="h-4 w-4 mt-1 flex-shrink-0" />
                <span>6 Chapel Market<br />London N1 9EZ</span>
              </div>
              <a 
                href="https://www.google.com/maps/place/6+Chapel+Market,+London+N1+9EZ" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block text-orange-500 hover:text-orange-400 transition-colors duration-300 font-semibold text-sm"
              >
                Get Directions →
              </a>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Opening Hours</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2 text-gray-400">
                <Clock className="h-4 w-4 mt-1" />
                <div>
                  <p className="text-white font-semibold">Open Daily</p>
                  <p className="text-sm">Closes at 23:30</p>
                </div>
              </div>
              <div className="flex flex-wrap gap-2 mt-4">
                <span className="bg-zinc-800 text-gray-300 px-3 py-1 rounded text-xs">
                  Dine-in
                </span>
                <span className="bg-zinc-800 text-gray-300 px-3 py-1 rounded text-xs">
                  Takeaway
                </span>
                <span className="bg-zinc-800 text-gray-300 px-3 py-1 rounded text-xs">
                  Delivery
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-zinc-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © 2025 N1 Grill. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors duration-300">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors duration-300">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
